import { AsyncContainerModule } from 'inversify'
import { FeatureName } from '@wix/thunderbolt-symbols'
import { FeatureLoaderParams, FeaturesLoaders, ILoadFeatures } from './Features'
import { IocContainer } from '@wix/thunderbolt-ioc'

export const createFeaturesLoader = (
	featuresLoader: FeaturesLoaders,
	featureLoaderParams: FeatureLoaderParams
): ILoadFeatures => {
	const load = (feature: FeatureName) => featuresLoader[feature](featureLoaderParams)
	const loadFeaturesIntoContainer = (
		container: IocContainer,
		featureNames: Array<FeatureName>,
		context: 'site' | 'page'
	): Promise<any> =>
		Promise.all(
			featureNames.map(async (featureName) => {
				const feature = await load(featureName as FeatureName)
				// @ts-ignore
				if (feature.loaders) {
					await container.legacy().loadAsync(
						// @ts-ignore
						...Object.values(feature.loaders).map(({ loader }) => new AsyncContainerModule(loader))
					)
				}
				// @ts-ignore
				const loader = feature[context]
				if (loader) {
					// @ts-ignore
					container.load(loader)
				}
			})
		)
	let pageFeatures = new Set<FeatureName>()
	return {
		getAllFeatureNames() {
			return Object.keys(featuresLoader) as Array<FeatureName>
		},
		getLoadedPageFeatures() {
			return [...pageFeatures]
		},
		loadSiteFeatures: (container, featureNames) =>
			loadFeaturesIntoContainer(container, featureNames as Array<FeatureName>, 'site'),
		loadPageFeatures: (container, featureNames) => {
			pageFeatures = new Set([...pageFeatures, ...featureNames])
			return loadFeaturesIntoContainer(container, featureNames as Array<FeatureName>, 'page')
		},
	}
}
